import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setCartErrorData } from '@yme/common/redux/cart/actions';
import { getCartErrorData } from '@yme/common/redux/cart/selectors';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { ICON_MAP } from './constants';
import { IconWrapper } from './styled';
export function GeneralMessageModal() {
    const isRightToLeft = useSelector(getRTL);
    const { state, title, description, primaryButtonContent, secondaryButtonContent } = useSelector(getModalData);
    const cartErrorData = useSelector(getCartErrorData);
    const dispatch = useDispatch();
    const handleHideModal = useCallback(() => {
        dispatch(setIsModalHide());
        if (cartErrorData) {
            dispatch(setCartErrorData(null));
        }
    }, [dispatch, cartErrorData]);
    return (React.createElement(StaticModalWindow, { onHide: handleHideModal, minHeight: "auto", staticModalSize: MD_MODAL, title: title, isRightToLeft: isRightToLeft, footerComponent: React.createElement(ModalWindowFooter, { isCancelButton: Boolean(secondaryButtonContent), isSubmitButton: true, submitButtonLabel: primaryButtonContent, cancelButtonLabel: secondaryButtonContent, onSubmit: handleHideModal }) },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, { state: state },
                React.createElement(SVGIcon, { type: ICON_MAP[state], size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description)));
}
